function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { SearchQuery, buildFilterSummary } from '@domain-group/fe-allhomes-search-api';
import { NotificationIcon, NotificationOnIcon } from '@domain-group/fe-co-icon';
import { SignInType } from '@domain-group/fe-allhomes-library';
import { DriverType, storageFactory } from '@domain-group/fe-helper';
import { withAllhomesContext } from '@domain-group/fe-co-allhomes-global-context';
import { withSendEvent } from '@domain-group/fe-co-analytics';
import { OnboardingPopup } from './onboarding-popup';
import { ActionPopup } from './action-popup';
import * as styles from './property-alert-button.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export class BasePropertyAlertButton extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "storage", void 0);
    _defineProperty(this, "updateButtonState", () => {
      this.setState({
        alertId: this.props.alertId,
        filterSummary: this.props.filterSummary
      });
    });
    _defineProperty(this, "handleAlertClicked", event => {
      var _this$props$onAlertCl, _this$props;
      event.preventDefault();
      event.stopPropagation();
      if (!this.props.isIdentityLoaded) {
        return;
      }
      (_this$props$onAlertCl = (_this$props = this.props).onAlertClick) === null || _this$props$onAlertCl === void 0 ? void 0 : _this$props$onAlertCl.call(_this$props);
      this.startPopupFlow();
    });
    _defineProperty(this, "startPopupFlow", () => {
      if (this.state.firstTimeUser) {
        this.setState({
          promoPopup: true,
          firstTimeUser: false
        });
        this.storage.setItem('firstTimeUser', false);
        this.storage.setItem('displayPromo', false);
      } else if (this.props.isSignedIn) {
        this.setState({
          displayActionPopup: true
        });
      } else {
        var _this$props$openSignI, _this$props2;
        (_this$props$openSignI = (_this$props2 = this.props).openSignIn) === null || _this$props$openSignI === void 0 ? void 0 : _this$props$openSignI.call(_this$props2, SignInType.PROPERTY_ALERT).then(success => {
          if (success) {
            this.displayPopup();
          }
        });
      }
    });
    _defineProperty(this, "displayPopup", () => {
      this.setState({
        displayActionPopup: true
      });
    });
    _defineProperty(this, "handleOnboadingContinue", () => {
      this.closeOnboardingPopup();
      this.startPopupFlow();
    });
    _defineProperty(this, "closeOnboardingPopup", () => this.setState({
      promoPopup: false,
      displayPromo: false
    }));
    _defineProperty(this, "closeActionPopup", () => this.setState({
      displayActionPopup: false,
      showCreateConfirmation: false
    }));
    _defineProperty(this, "createPropertyAlert", frequency => {
      var _this$props$createPro, _this$props3;
      var alert = {
        id: this.state.alertId,
        listingType: this.props.listingType,
        query: this.props.query,
        name: this.props.alertName,
        frequency: frequency.toUpperCase()
      };
      (_this$props$createPro = (_this$props3 = this.props).createPropertyAlert) === null || _this$props$createPro === void 0 ? void 0 : _this$props$createPro.call(_this$props3, alert).then(result => {
        if (result) {
          var _this$props$onCreateA, _this$props4, _this$props$sendEvent, _this$props5;
          (_this$props$onCreateA = (_this$props4 = this.props).onCreateAlert) === null || _this$props$onCreateA === void 0 ? void 0 : _this$props$onCreateA.call(_this$props4, result);
          (_this$props$sendEvent = (_this$props5 = this.props).sendEvent) === null || _this$props$sendEvent === void 0 ? void 0 : _this$props$sendEvent.call(_this$props5, 'create-property-alert');
          this.setState({
            showCreateConfirmation: true,
            alertId: result.id,
            filterSummary: buildFilterSummary(new SearchQuery(this.props.listingType, result.query))
          });
        }
      });
    });
    _defineProperty(this, "removePropertyAlert", () => {
      var _this$props$onRemoveA, _this$props6;
      (_this$props$onRemoveA = (_this$props6 = this.props).onRemoveAlert) === null || _this$props$onRemoveA === void 0 ? void 0 : _this$props$onRemoveA.call(_this$props6);
      if (this.state.alertId) {
        var _this$props$removePro, _this$props7;
        (_this$props$removePro = (_this$props7 = this.props).removePropertyAlert) === null || _this$props$removePro === void 0 ? void 0 : _this$props$removePro.call(_this$props7, this.state.alertId).then(() => {
          var _this$props$deleteCon, _this$props8;
          this.setState({
            alertId: null
          });
          this.closeActionPopup();
          (_this$props$deleteCon = (_this$props8 = this.props).deleteConfirmation) === null || _this$props$deleteCon === void 0 ? void 0 : _this$props$deleteCon.call(_this$props8);
        });
      }
    });
    _defineProperty(this, "editPropertyAlert", () => {
      var _this$props$onEditAle, _this$props9;
      (_this$props$onEditAle = (_this$props9 = this.props).onEditAlert) === null || _this$props$onEditAle === void 0 ? void 0 : _this$props$onEditAle.call(_this$props9);
      if (typeof window !== 'undefined') {
        window.location.href = this.props.editAlertUrl + this.state.alertId;
      }
    });
    _defineProperty(this, "managePropertyAlerts", () => {
      var _this$props$onManageA, _this$props0;
      (_this$props$onManageA = (_this$props0 = this.props).onManageAlert) === null || _this$props$onManageA === void 0 ? void 0 : _this$props$onManageA.call(_this$props0);
      if (typeof window !== 'undefined') {
        window.location.href = this.props.manageAlertUrl;
      }
    });
    this.storage = storageFactory({
      name: 'alert',
      driver: DriverType.LOCALSTORAGE
    });
    this.state = {
      promoPopup: false,
      displayActionPopup: false,
      showCreateConfirmation: false,
      firstTimeUser: this.storage.getItem('firstTimeUser') === null,
      displayPromo: this.storage.getItem('displayPromo') === null,
      alertId: null,
      filterSummary: ''
    };
  }
  componentDidMount() {
    if (this.props.alertId) {
      this.updateButtonState();
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.alertId !== prevProps.alertId && this.props.alertId !== this.state.alertId) {
      this.updateButtonState();
    }
  }
  render() {
    var alertId = this.state.alertId;
    var _this$props1 = this.props,
      isIdentityLoaded = _this$props1.isIdentityLoaded,
      appearance = _this$props1.appearance;
    var BellIcon = alertId ? NotificationOnIcon : NotificationIcon;
    return ___EmotionJSX("div", {
      className: this.props.className,
      css: styles.container
    }, ___EmotionJSX("button", {
      "aria-label": "Property alert",
      css: styles.alertButton({
        alertId,
        isIdentityLoaded,
        appearance
      }),
      onClick: this.handleAlertClicked,
      type: "button"
    }, ___EmotionJSX(BellIcon, {
      css: styles.bellIcon,
      size: "regular"
    }), ___EmotionJSX("span", {
      css: appearance === 'no-results' ? styles.noResultsbuttonLabel : styles.buttonLabel
    })), this.state.promoPopup && this.state.displayPromo && ___EmotionJSX(OnboardingPopup, {
      onClose: this.closeOnboardingPopup,
      displayCreatePopup: this.handleOnboadingContinue
    }), this.state.displayActionPopup && !this.state.displayPromo && ___EmotionJSX(ActionPopup, {
      onClose: this.closeActionPopup,
      createPropertyAlert: this.createPropertyAlert,
      editPropertyAlert: this.editPropertyAlert,
      removePropertyAlert: this.removePropertyAlert,
      managePropertyAlerts: this.managePropertyAlerts,
      showCreateConfirmation: this.state.showCreateConfirmation,
      alertId: this.state.alertId,
      alertName: this.props.alertName,
      filterSummary: this.state.filterSummary,
      searchQuery: this.props.query
    }));
  }
}
_defineProperty(BasePropertyAlertButton, "defaultProps", {
  appearance: 'filters',
  deleteConfirmation: () => {},
  query: null,
  onAlertClick: () => {},
  onCreateAlert: () => Promise.resolve(null),
  onManageAlert: () => {},
  onEditAlert: () => {},
  onRemoveAlert: () => {},
  alertId: null,
  filterSummary: '',
  isSignedIn: false,
  openSignIn: () => Promise.resolve(false),
  createPropertyAlert: () => Promise.resolve(null),
  removePropertyAlert: () => Promise.resolve(),
  isIdentityLoaded: false
});
export var PropertyAlertButton = withSendEvent(withAllhomesContext('isSignedIn', 'openSignIn', 'createPropertyAlert', 'removePropertyAlert', 'isIdentityLoaded')(BasePropertyAlertButton));